export const anmClassificationCatalogPtBR = {
  "sections": {
    "cri": {
      "label": "CRI",
      "subtitle": "1 - Classificação de risco"
    },
    "dpa": {
      "label": "DPA",
      "subtitle": "2 - Dano potencial associado"
    },
    "go": {
      "label": "Gestão operacional",
      "subtitle": "3 - Gestão operacional"
    }
  },
  "grades": {
    "ct": {
      "fullTitle": "1.1 - Características técnicas - CT"
    },
    "ec": {
      "fullTitle": "1.2 - Estado de conservação - EC"
    },
    "psb": {
      "fullTitle": "1.3 - Plano de segurança da barragem - PSB"
    },
    "dpa": {
      "fullTitle": "2 - Classificação quanto ao dano potencial associado - DPA (resíduos e rejeitos)"
    },
    "go": {
      "fullTitle": "3 - Classificação quanto à gestão operacional"
    }
  },
  "columns": {
    "ctA": {
      "title": "Altura"
    },
    "ctB": {
      "title": "Inclinação média dos taludes na seção principal"
    },
    "ctC": {
      "title": "Comprimento"
    },
    "ctD": {
      "title": "Vazão de Projeto"
    },
    "ctE": {
      "title": "Controle de compactação"
    },
    "ctF": {
      "title": "Existência de drenagem interna"
    },
    "ctG": {
      "title": "Fundação"
    },
    "ctH": {
      "title": "Método Construtivo"
    },
    "ctI": {
      "title": "Instrumentação"
    },
    "ctJ": {
      "title": "Idade da barragem"
    },
    "ecK": {
      "title": "Confiabilidade das Estruturas Extravasoras"
    },
    "ecL": {
      "title": "Percolação"
    },
    "ecM": {
      "title": "Deformações e Recalques"
    },
    "ecN": {
      "title": "Deterioração dos Taludes / Paramentos"
    },
    "ecO": {
      "title": "Drenagem Superficial"
    },
    "psbP": {
      "title": "Documentação de Projeto"
    },
    "psbQ": {
      "title": "Estrutura Organizacional e Qualificação dos Profissionais na Equipe de Segurança da Barragem"
    },
    "psbR": {
      "title": "Manuais de Procedimentos para inspeções de Segurança e Monitoramento"
    },
    "psbS": {
      "title": "Plano de Ação Emergencial PAE (quando exigido pelo órgão fiscalizador)"
    },
    "psbT": {
      "title": "Relatórios de inspeção e monitoramento da instrumentação e de Análise de Segurança"
    },
    "dpaA": {
      "title": "Volume Total do Reservatório"
    },
    "dpaB": {
      "title": "Existência de população a Jusante"
    },
    "dpaC": {
      "title": "Impacto ambiental"
    },
    "dpaD": {
      "title": "Impacto socioeconômico"
    },
    "goA": {
      "title": "Declaração de Condição de Estabilidade RISR enviada"
    },
    "goB": {
      "title": "Declaração de Condição de Estabilidade RPSB enviada"
    },
    "goC": {
      "title": "Declaração de Conformidade e Operacionalidade enviada"
    },
    "goD": {
      "title": "Extrato de Inspeção enviado"
    },
    "goE": {
      "title": "Existência de EdR"
    },
    "goF": {
      "title": "Programa de Gestão de Risco para Barragens de Mineração — PGRBM"
    },
    "goG": {
      "title": "Certificação e/ou padrões da indústria"
    }
  },
  "options": {
    "ctA": {
      "score0": "Altura ≤ 15m",
      "score1": "15m < Altura < 30m",
      "score4": "30m ≤ Altura ≤ 60m",
      "score7": "Altura > 60m"
    },
    "ctB": {
      "score0": "Suave (≤ 1V:3H) ou barragem de concreto",
      "score3": "Intermediário (1V:2H ≥ Inclinação > 1V:3H)",
      "score6": "Íngrime (> 1V:2H)"
    },
    "ctC": {
      "score0": "Comprimento ≤ 50m",
      "score1": "50m < Comprimento < 200m",
      "score2": "200 ≤ Comprimento ≤ 600m",
      "score3": "Comprimento > 600m"
    },
    "ctD": {
      "score0": "CMP (Cheia Máxima Provável) ou Decamilenar",
      "score2": "Milenar",
      "score5": "TR = 500 anos",
      "score10": "TR Inferior a 500 anos ou desconhecida/ Estudo não confiável"
    },
    "ctE": {
      "score0": "Existem documentos que comprovam o controle de compactação conforme projeto e que comprovam o acompanhamento e controle tecnológico durante a execução",
      "score4": "Existem estudos geotécnicos que comprovam o grau de compactação de acordo com projeto",
      "score10": "Não houve controle tecnológico e/ou não há informação e/ou compactação em desacordo com o projeto"
    },
    "ctF": {
      "score0": "Drenagem construída conforme projeto ou não existe drenagem em projeto",
      "score4": "Drenagem corretiva construída posteriormente a conclusão da barragem",
      "score10": "Sistema de drenagem em desacordo com projeto ou inexistente ou desconhecida ou estudo não confiável ou inoperante"
    },
    "ctG": {
      "score0": "Fundação investigada conforme projeto",
      "score6": "Fundação parcialmente investigada",
      "score10": "Fundação desconhecida/Estudo não confiável"
    },
    "ctH": {
      "score0": "Etapa única",
      "score2": "Alteamento a jusante",
      "score5": "Alteamento por linha de centro",
      "score10": "Alteamento a montante ou desconhecido"
    },
    "ctI": {
      "score0": "Existe instrumentação de acordo com o projeto técnico",
      "score2": "Existe instrumentação em desacordo com o projeto, porém em processo de instalação de instrumentos para adequação ao projeto",
      "score6": "Existe instrumentação em desacordo com o projeto sem processo de instalação de instrumentos para adequação ao projeto",
      "score8": "Barragem não instrumentada em desacordo com o projeto"
    },
    "ctJ": {
      "score1": "Entre 5 e 15 anos",
      "score2": "Entre 15 e 30 anos",
      "score3": "< 5 anos ou > 30 anos ou sem informação"
    },
    "ecK": {
      "score0": "Estruturas civis bem mantidas e em operação normal /barragem sem necessidade de estruturas extravasoras",
      "score3": "Estruturas com problemas identificados e medidas corretivas em implantação",
      "score6": "Estruturas com problemas identificados e sem implantação das medidas corretivas necessárias, sem restrição operacional e extravasor com capacidade plena",
      "score10": "Estruturas com problemas identificados, com redução de capacidade vertente e sem medidas corretivas"
    },
    "ecL": {
      "score0": "Percolação totalmente controlada pelo sistema de drenagem",
      "score3": "Umidade ou surgência nas áreas de jusante, paramentos, taludes e ombreiras estáveis e monitorados",
      "score6": "Umidade ou surgência nas áreas de jusante, paramentos, taludes ou ombreiras sem implantação das medidas corretivas necessárias",
      "score10": "Surgência nas áreas de jusante com carreamento de material ou com vazão crescente ou infiltração do material contido, com potencial de comprometimento da segurança da estrutura"
    },
    "ecM": {
      "score0": "Não existem deformações e recalques com potencial de comprometimento da segurança da estrutura",
      "score2": "Existência de trincas e abatimentos com medidas corretivas em implantação",
      "score6": "Existência de trincas e abatimentos sem implantação das medidas corretivas necessárias",
      "score10": "Existência de trincas, abatimentos ou escorregamentos, com potencial de comprometimento da segurança da estrutura"
    },
    "ecN": {
      "score0": "Não existe deterioração de taludes e paramentos",
      "score2": "Falhas na proteção dos taludes e paramentos, presença de vegetação arbustiva",
      "score6": "Erosões superficiais, ferragem exposta, presença de vegetação arbórea, sem implantação das medidas corretivas necessárias.",
      "score10": "Depressões acentuadas nos taludes, escorregamentos, sulcos profundos de erosão, com potencial de comprometimento da segurança da estrutura"
    },
    "ecO": {
      "score0": "Drenagem superficial existente e operante",
      "score2": "Existência de trincas e/ou assoreamento e/ou abatimentos com medidas corretivas em implantação",
      "score4": "Existência de trincas e/ou assoreamento e/ou abatimentos sem medidas corretivas em implantação",
      "score5": "Drenagem superficial inexistente"
    },
    "psbP": {
      "score0": "Projeto executivo e \"como construído\"",
      "score2": "Projeto executivo ou \"como construído\"",
      "score3": "Projeto \"como está\"",
      "score5": "Projeto básico",
      "score8": "Projeto conceitual",
      "score10": "Não há documentação de projeto"
    },
    "psbQ": {
      "score0": "Possui unidade administrativa com profissional técnico qualificado responsável pela segurança da barragem ou é barragem não enquadrada nos incisos I, II, III ou IV, parágrafo único do art. 1° da Lei n° 12.334/2010",
      "score1": "Possui profissional técnico qualificado (próprio ou contratado) responsável pela segurança da barragem",
      "score3": "Possui unidade administrativa sem profissional técnico qualificado responsável pela segurança da barragem",
      "score6": "Não possui unidade administrativa e responsável técnico qualificado pela segurança da barragem"
    },
    "psbR": {
      "score0": "Possui manuais de procedimentos para inspeção, monitoramento e operação ou é barragem não enquadrada nos incisos I, II, III ou IV, parágrafo único do art. 1° da Lei n° 12.334/2010",
      "score2": "Possui apenas manual de procedimentos de monitoramento",
      "score4": "Possui apenas manual de procedimentos de inspeção",
      "score8": "Não possui manuais ou procedimentos formais para monitoramento e inspeções"
    },
    "psbS": {
      "score0": "Possui PAE",
      "score2": "Não possui PAE (não é exigido pelo órgão fiscalizador)",
      "score4": "PAE em elaboração",
      "score8": "Não possui PAE (quando for exigido pelo órgão fiscalizador)"
    },
    "psbT": {
      "score0": "Emite regularmente relatórios de inspeção e monitoramento com base na instrumentação e de Análise de Segurança ou é barragem não enquadrada nos incisos I, II, III ou IV, parágrafo único do art. 1° da Lei n° 12.334/2010",
      "score2": "Emite regularmente apenas relatórios de Análise de Segurança",
      "score4": "Emite regularmente apenas relatórios de inspeção e monitoramento",
      "score6": "Emite regularmente apenas relatórios de inspeção visual",
      "score8": "Não emite regularmente relatórios de inspeção e monitoramento e de Análise de Segurança"
    },
    "dpaA": {
      "score1": "Muito Pequeno ≤ 500 mil m³",
      "score2": "Pequeno: 500 mil a 5 milhões m³",
      "score3": "Médio: 5 milhões a 25 milhões m³",
      "score4": "Grande: 25 milhões a 50 milhões m³",
      "score5": "Muito Grande ≥ 50 milhões m³"
    },
    "dpaB": {
      "score0": "INEXISTENTE — não existem pessoas permanentes/residentes ou temporárias/transitando na área afetada a jusante da barragem",
      "score3": "POUCO FREQUENTE — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe estrada vicinal de uso local",
      "score5": "FREQUENTE — não existem pessoas ocupando permanentemente a área afetada a jusante da barragem, mas existe rodovia municipal ou estadual ou federal ou outro local e/ou empreendimento de permanência eventual de pessoas que poderão ser atingidas",
      "score10": "EXISTENTE — existem pessoas ocupando permanentemente a área afetada a jusante da barragem, portanto, vidas humanas poderão ser atingidas"
    },
    "dpaC": {
      "score0": "INSIGNIFICANTE — área afetada a jusante da barragem encontra-se totalmente descaracterizada de suas condições naturais e a estrutura armazena apenas resíduos Classe II B - Inertes, segundo a NBR 10004 da ABNT",
      "score2": "POUCO SIGNIFICATIVO — área afetada a jusante da barragem (não apresenta área de interesse ambiental relevante ou áreas protegidas em legislação específica, excluídas APPs, e armazena apenas resíduos Classe II B - Inertes, segundo a NBR 10004 da ABNT)",
      "score6": "SIGNIFICATIVO — área afetada a jusante da barragem apresenta área de interesse ambiental relevante ou áreas protegidas em legislação específica, excluídas APPs, e armazena apenas resíduos Classe II B - Inertes, segundo a NBR 10.004 da ABNT",
      "score8": "MUITO SIGNIFICATIVO — barragem armazena rejeitos ou resíduos sólidos classificados na Classe II A - Não Inertes, segundo a NBR 10004 da ABNT",
      "score10": "MUITO SIGNIFICATIVO AGRAVADO — barragem armazena rejeitos ou resíduos sólidos classificados na Classe I - Perigosos segundo a NBR 10.004 da ABNT"
    },
    "dpaD": {
      "score0": "INEXISTENTE — não existem quaisquer instalações na área afetada a jusante da barragem",
      "score1": "BAIXO — existe pequena concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômica cultural na área afetada a jusante da barragem",
      "score3": "MÉDIO — existe moderada concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico cultural na área afetada a jusante da barragem",
      "score5": "ALTO — existe alta concentração de instalações residenciais, agrícolas, industriais ou de infraestrutura de relevância socioeconômico cultural na área afetada a jusante da barragem"
    },
    "goA": {
      "score0": "Atestando a estabilidade nos últimos 3 anos",
      "score1": "Atestando a estabilidade durante o último semestre",
      "score8": "Não atestando",
      "score10": "Não enviada"
    },
    "goB": {
      "score0": "Atestando a estabilidade nos últimos 5 anos",
      "score1": "Atestando a estabilidade referente a última enviada",
      "score8": "Não atestando",
      "score10": "Não enviada"
    },
    "goC": {
      "score0": "Atestando à conformidade nos últimos 3 anos",
      "score1": "Atestando à conformidade durante o último ano",
      "score8": "Não atestando",
      "score10": "Não enviada"
    },
    "goD": {
      "score0": "Dentro dos prazos legais e sem registro de anomalia pontuação 4, 6 ou 10 no EC durante os últimos 2 anos",
      "score1": "Dentro dos prazos legais e sem registro de anomalia pontuação 4, 6 ou 10 no EC durante último semestre",
      "score2": "Fora dos prazos legais ou dentro dos prazos legais, mas com registro de anomalia pontuação 4, 6 ou 10 no EC durante o último semestre",
      "score6": "Com pendências de envio durante o último semestre",
      "score10": "Não enviado mais de 4 extratos subsequentes ou intercalados durante o último semestre"
    },
    "goE": {
      "score0": "Existe Engenheiro de Registro contratado",
      "score1": "Não existe Engenheiro de Registro contratado (não é exigido pelo órgão fiscalizador)",
      "score10": "Não existe Engenheiro de Registros contratado (quando exigido pelo órgão fiscalizador)"
    },
    "goF": {
      "score0": "Possui PGRBM",
      "score1": "Não possui PGRBM (não é exigido pelo órgão fiscalizador)",
      "score4": "PGRBM em elaboração",
      "score9": "Não possui PGRBM (quando for exigido pelo órgão fiscalizador)"
    },
    "goG": {
      "score0": "Possui ISO 31.000 ou adota o TSM ou ICMM",
      "score1": "Não possui ISO 31.000 ou não adota o TSM ou ICMM"
    }
  }
} as const;
